export default __webpack_public_path__ + "static/media/azich.6bd9a6e5.png";